export type PhoneSexBlock = {
	number: {
		tele: string,
		first: string,
	},
	title: string,
	subline: string,
	imageUrl: string
};

export enum Callcenter {
	first= 'first',
	tele = 'tele',
}

export type PhoneSexCategory = 'luder'|'oma'|'hausfrau'|'anal'|'milf'|'teens'|'bigtits'|'twenty'|'domina'|'seitensprung';

export type PhoneSexCategories = Record<PhoneSexCategory, PhoneSexBlock>;

export const PhoneSexNumbers: PhoneSexCategories = {
	luder: {
		number: {
			first: '09007 001 196',
			tele: '09007 001 092 ',
		},
		title: 'Scharfe Luder',
		subline: 'wollen jetzt deinen heißen Schwanz',
		imageUrl: '/img/telefonsex/overview/luder.jpg',
	},
	oma: {
		number: {
			first: '09007 001 198',
			tele: '09007 001 094',
		},
		title: 'Reife Omas',
		subline: 'möchten dir ihre geheimen Sex-Wünsche gestehen',
		imageUrl: '/img/telefonsex/overview/oma.jpg',
	},
	hausfrau: {
		number: {
			first: '09007 001 193',
			tele: '09007 001 107',
		},
		title: 'Einsame Haus&shy;frauen',
		subline: 'warten auf dich',
		imageUrl: '/img/telefonsex/overview/hausfrau.jpg',
	},
	anal: {
		number: {
			first: '09007 103 890',
			tele: '09007 001 091',
		},
		title: 'Rattige Anal-Huren',
		subline: 'wollen es hart in ihr enges Po-Loch kriegen',
		imageUrl: '/img/telefonsex/overview/anal.jpg',
	},
	milf: {
		number: {
			first: '09007 001 197',
			tele: '09007 001 093',
		},
		title: 'Will&shy;fährige MILFs',
		subline: 'sind erfahren und zu allem bereit',
		imageUrl: '/img/telefonsex/overview/milfs.jpg',
	},
	domina: {
		number: {
			first: '09007 104 605',
			tele: '09007 001 089',
		},
		title: 'Extreme Dominas',
		subline: 'zeigen dir, wo es lang geht',
		imageUrl: '/img/telefonsex/overview/domina.jpg',
	},
	teens: {
		number: {
			first: '09007 001 194',
			tele: '09007 001 096',
		},
		title: 'Uner&shy;fahrene Teens (18+)',
		subline: 'sind scharf darauf von ihrer ersten Erfahrung zu berichten',
		imageUrl: '/img/telefonsex/overview/teen.jpg',
	},
	twenty: {
		number: {
			first: '09007 071 421',
			tele: '09007 001 097',
		},
		title: 'Sexy zwanziger (20+)',
		subline: 'wollen jetzt direkt ihre Lust ausleben',
		imageUrl: '/img/telefonsex/overview/frauen20plus.jpg',
	},
	bigtits: {
		number: {
			first: '09007 822 552',
			tele: '09007 000 671',
		},
		title: 'Riesen Titten',
		subline: 'lieben es massiert und geknetet zu werden',
		imageUrl: '/img/telefonsex/overview/grosse_brueste.jpg'
	},
	seitensprung: {
		number: {
			first: '09007 001 203',
			tele: '09007 000 678',
		},
		title: 'Heisse Seiten&shy;sprünge',
		subline: 'suchen jemand für ein unge&shy;zwungenes Stell&shy;dichein',
		imageUrl: '/img/telefonsex/overview/seitensprung.jpg'
	},
};
